export default [
  {
    path: '/notPermission',
    name: 'notPermission',
    component: () => import('@/views/common/notPermission.vue'),
    meta: {
      title: '无权限'
    }
  }
]